/* Movimiento de Rosvelet: reveal, titulares por palabra, scroll unico, ripple, transiciones de pagina. Expone window.RVM. */
(function () {
  'use strict';

  var root = document.documentElement;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
  function R() { return mq.matches; }
  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var NATIVE_VT = !root.classList.contains('no-vt');
  root.classList.add('rv');

  /* ---------- Reveal: un solo IntersectionObserver ---------- */
  var pending = [];
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { io.unobserve(e.target); show(e.target); } });
  }, { rootMargin: '0px 0px -6% 0px', threshold: 0 }) : null;

  function hint(el) {
    el.style.willChange = 'transform, opacity';
    var off = function () { el.style.willChange = ''; };
    el.addEventListener('transitionend', off, { once: true });
    setTimeout(off, 1800);
  }
  function kidsOf(c) { return Array.prototype.filter.call(c.children, function (k) { return k.nodeType === 1; }); }
  function show(el) {
    var i = pending.indexOf(el); if (i > -1) pending.splice(i, 1);
    var delay = parseInt(el.dataset.delay, 10);
    if (delay) el.style.setProperty('--d', delay + 'ms');
    if (el.hasAttribute('data-stagger')) {
      kidsOf(el).forEach(function (k, n) { k.style.setProperty('--d', Math.min(n, 8) * 70 + 'ms'); hint(k); k.classList.add('in'); });
    } else hint(el);
    el.classList.add('in');
    $$('[data-count]', el).forEach(count);
    if (el.matches('[data-count]')) count(el);
  }
  function watch(el) {
    if (!io) { el.classList.add('in'); return; }
    io.observe(el); pending.push(el);
  }

  function count(el) {
    if (el._counted) return;
    el._counted = 1;
    var to = parseFloat(el.dataset.count), dec = parseInt(el.dataset.dec, 10) || 0, t0 = performance.now();
    if (R()) { el.textContent = to.toFixed(dec).replace('.', ','); return; }
    (function step(t) {
      var k = clamp((t - t0) / 1400, 0, 1), e = 1 - Math.pow(1 - k, 3);
      el.textContent = (to * e).toFixed(dec).replace('.', ',');
      if (k < 1) requestAnimationFrame(step);
    })(t0);
  }

  /* ---------- Titulares por palabra (texto accesible intacto) ---------- */
  function splitHeading(h) {
    if (h._split) return; h._split = 1;
    var label = h.textContent.replace(/\s+/g, ' ').trim(), n = 0;
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (c) {
        if (c.nodeType === 3) {
          var frag = document.createDocumentFragment();
          c.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
            var w = document.createElement('span'), wi = document.createElement('span');
            w.className = 'w'; w.setAttribute('aria-hidden', 'true');
            wi.className = 'wi'; wi.style.setProperty('--i', n++); wi.textContent = part;
            w.appendChild(wi); frag.appendChild(w);
          });
          node.replaceChild(frag, c);
        } else if (c.nodeType === 1 && c.nodeName !== 'BR') walk(c);
      });
    })(h);
    var sr = document.createElement('span'); sr.className = 'sr'; sr.textContent = label;
    h.insertBefore(sr, h.firstChild);
    if (!h.hasAttribute('data-reveal')) h.setAttribute('data-reveal', 'words');
  }

  function refresh(scope) {
    scope = scope || document;
    if (!R()) $$('main h1.display, main h2.display, main h3.display, .site-footer h2.display', scope).forEach(function (h) {
      if (!h.closest('.drawer, .empty, .success, .notfound, .rev-form')) splitHeading(h);
    });
    $$('[data-stagger]', scope).forEach(function (c) {
      var v = c.dataset.stagger || 'up';
      kidsOf(c).forEach(function (k) {
        if (k.hasAttribute('data-sub')) return;
        k.setAttribute('data-sub', ''); if (!k.hasAttribute('data-reveal')) k.setAttribute('data-reveal', v);
        if (c.classList.contains('in')) k.classList.add('in');
      });
      if (!c._rv) { c._rv = 1; watch(c); }
    });
    $$('[data-reveal]', scope).forEach(function (el) {
      if (el._rv || el.hasAttribute('data-sub')) return;
      el._rv = 1; watch(el);
    });
  }

  /* ---------- Bus de scroll: un solo handler pasivo + rAF ---------- */
  var tasks = [], ticking = false, lastY = window.scrollY, maxY = 1, activeUntil = 0, wcOn = false;
  var header = $('#site-header'), bar = $('.progress');
  var para = $$('[data-parallax]');
  var wcEls = para;

  function schedule() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
  function measure() { maxY = Math.max(1, root.scrollHeight - window.innerHeight); schedule(); }

  function frame(t) {
    ticking = false;
    var reduced = R(), y = window.scrollY, vh = window.innerHeight, now = performance.now();
    /* lecturas */
    var rects = reduced ? [] : para.map(function (el) { return el.closest('[data-parallax-root]').getBoundingClientRect(); });
    var atEnd = y >= maxY - 2;
    var gone = pending.filter(function (el) { var r = el.getBoundingClientRect(); return r.bottom < 0 || (atEnd && r.top < vh); });
    tasks.forEach(function (k) { if (k.read) k.read(y); });
    /* escrituras */
    if (header) { if (y > 60) header.classList.add('is-compact'); else if (y < 20) header.classList.remove('is-compact'); }
    if (bar && !reduced) bar.style.transform = 'scaleX(' + clamp(y / maxY, 0, 1).toFixed(4) + ')';
    gone.forEach(function (el) { io.unobserve(el); el.style.transition = 'none'; show(el); });
    if (Math.abs(y - lastY) > 0) activeUntil = now + 250;
    var live = now < activeUntil;
    if (!reduced) {
      if (live !== wcOn) { wcOn = live; wcEls.forEach(function (el) { el.style.willChange = live ? 'transform' : ''; }); }
      para.forEach(function (el, i) {
        var r = rects[i]; if (r.bottom < 0 || r.top > vh) return;
        var dy = (r.top + r.height / 2 - vh / 2) * parseFloat(el.dataset.parallax);
        el.style.transform = 'translate3d(0,' + dy.toFixed(1) + 'px,0)';
      });
    }
    tasks.forEach(function (k) { if (k.write) k.write(y); });
    lastY = y;
    if (live || gone.length) schedule();
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', measure, { passive: true });
  window.addEventListener('load', measure);
  var mT = 0;
  if ('ResizeObserver' in window) new ResizeObserver(function () { clearTimeout(mT); mT = setTimeout(measure, 120); }).observe(document.body);
  /* Terminada la entrada por recorte, se quita el clip-path: si no, recorta los anillos de foco. */
  document.addEventListener('transitionend', function (e) {
    if (e.propertyName === 'clip-path' && e.target.matches && e.target.matches('[data-reveal="clip"], .card__media')) e.target.classList.add('clip-done');
  });

  /* ---------- Tilt de tarjetas (puntero fino) ---------- */
  var tiltEl = null, tiltRect = null, tx = 0, ty = 0, tiltRaf = 0;
  function tiltWrite() {
    tiltRaf = 0; if (!tiltEl) return;
    tiltEl.style.setProperty('--ry', ((tx - 0.5) * 8).toFixed(2) + 'deg');
    tiltEl.style.setProperty('--rx', ((0.5 - ty) * 8).toFixed(2) + 'deg');
  }
  function tiltEnd() {
    if (!tiltEl) return;
    tiltEl.style.removeProperty('--rx'); tiltEl.style.removeProperty('--ry');
    tiltEl.closest('.card').classList.remove('tilting'); tiltEl = null;
  }
  document.addEventListener('pointermove', function (e) {
    if (e.pointerType !== 'mouse' || R()) return;
    var m = e.target.closest ? e.target.closest('.card__media') : null;
    if (m !== tiltEl) { tiltEnd(); if (m) { tiltEl = m; tiltRect = m.getBoundingClientRect(); m.closest('.card').classList.add('tilting'); } }
    if (!tiltEl) return;
    tx = clamp((e.clientX - tiltRect.left) / tiltRect.width, 0, 1);
    ty = clamp((e.clientY - tiltRect.top) / tiltRect.height, 0, 1);
    if (!tiltRaf) tiltRaf = requestAnimationFrame(tiltWrite);
  }, { passive: true });
  document.addEventListener('pointerleave', tiltEnd);
  window.addEventListener('scroll', tiltEnd, { passive: true });

  /* ---------- Ripple en botones ---------- */
  document.addEventListener('pointerdown', function (e) {
    if (R() || (e.pointerType === 'mouse' && e.button)) return;
    var b = e.target.closest ? e.target.closest('.btn, .qty button') : null;
    if (!b || b.classList.contains('is-busy')) return;
    var r = b.getBoundingClientRect(), s = Math.max(r.width, r.height) * 2.2, d = document.createElement('span');
    d.className = 'rip'; d.setAttribute('aria-hidden', 'true');
    d.style.cssText = 'width:' + s + 'px;height:' + s + 'px;left:' + (e.clientX - r.left - s / 2) + 'px;top:' + (e.clientY - r.top - s / 2) + 'px';
    b.appendChild(d);
    d.addEventListener('animationend', function () { d.remove(); }, { once: true });
  }, { passive: true });

  /* ---------- Navegacion entre paginas ---------- */
  function go(url) {
    if (NATIVE_VT || R()) { location.href = url; return; }
    root.classList.add('leaving');
    setTimeout(function () { location.href = url; }, 200);
  }
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || (a.target && a.target !== '_self') || a.hasAttribute('download') || a.hasAttribute('data-open-cart')) return;
    var u = new URL(a.href, location.href);
    if (u.protocol !== location.protocol || u.host !== location.host) return;
    if (u.pathname === location.pathname && u.search === location.search) return; // solo hash o misma pagina
    if (NATIVE_VT || R()) return;
    e.preventDefault(); go(u.href);
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) root.classList.remove('leaving'); });

  /* ---------- Acordeones (fallback sin ::details-content) ---------- */
  function initAcc(scope) {
    if (!root.classList.contains('no-dc')) return;
    $$('.acc:not([data-acc])', scope).forEach(function (d) {
      d.setAttribute('data-acc', '');
      var body = $('.acc__body', d), g = document.createElement('div'), inn = document.createElement('div');
      g.className = 'acc__grid' + (d.open ? ' x' : ''); inn.className = 'acc__in';
      body.parentNode.insertBefore(g, body); inn.appendChild(body); g.appendChild(inn);
      $('summary', d).addEventListener('click', function (ev) {
        ev.preventDefault(); clearTimeout(d._t);
        if (R()) { d.open = !d.open; g.classList.toggle('x', d.open); return; }
        if (d.open) { g.classList.remove('x'); d._t = setTimeout(function () { d.open = false; }, 330); }
        else { d.open = true; requestAnimationFrame(function () { requestAnimationFrame(function () { g.classList.add('x'); }); }); }
      });
    });
  }

  /* ---------- Utilidades de animacion ---------- */
  function roll(el, text, dir) {
    text = String(text);
    if (R() || !el.animate || el.textContent === text || !el.isConnected) { el.textContent = text; return; }
    var old = el.textContent;
    el.innerHTML = '<span class="rsz"></span><span class="roll" aria-hidden="true"><span></span><span></span></span>';
    el.firstChild.textContent = text;
    var cells = el.lastChild.children, up = dir !== 'down';
    cells[0].textContent = up ? old : text; cells[1].textContent = up ? text : old;
    var a = el.lastChild.animate(up ? [{ transform: 'translateY(0)' }, { transform: 'translateY(-50%)' }] : [{ transform: 'translateY(-50%)' }, { transform: 'translateY(0)' }],
      { duration: 320, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'both' });
    a.onfinish = a.oncancel = function () { el.textContent = text; };
  }
  function rollIn(el, dir) {
    if (R() || !el.animate) return;
    el.animate([{ transform: 'translateY(' + (dir === 'down' ? -45 : 45) + '%)', opacity: 0 }, { transform: 'none', opacity: 1 }], { duration: 280, easing: 'cubic-bezier(.2,.7,.2,1)' });
  }

  var lastVals = {}, rafs = {};
  var money = function (n) { return window.Rosvelet.money(Math.round(n)); };
  function tweenMoney(el, to, key) {
    var from = key in lastVals ? lastVals[key] : to;
    cancelAnimationFrame(rafs[key]);
    if (R() || from === to) { lastVals[key] = to; el.textContent = money(to); return; }
    var t0 = performance.now();
    (function step(t) {
      var k = clamp((t - t0) / 420, 0, 1), v = from + (to - from) * (1 - Math.pow(1 - k, 3));
      lastVals[key] = v; el.textContent = money(v);
      if (k < 1) rafs[key] = requestAnimationFrame(step); else lastVals[key] = to;
    })(t0);
  }

  function shake(el) {
    if (R() || !el.animate) return;
    el.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(5px)' }, { transform: 'translateX(-3px)' }, { transform: 'translateX(0)' }], { duration: 360, easing: 'ease-out' });
  }

  function bump(el, scale) {
    if (R() || !el || !el.animate) return;
    el.animate([{ scale: 1 }, { scale: scale || 1.3 }, { scale: 1 }], { duration: 420, easing: 'cubic-bezier(.34,1.56,.64,1)' });
  }

  /* Vuelo al carrito: x con ease-out, y con ease-in => trayectoria curva */
  function fly(src, land) {
    var cart = $('.cart-btn');
    if (R() || !cart || !src || !src.animate) { land(); return; }
    var s = src.getBoundingClientRect(), c = cart.getBoundingClientRect(), size = 84;
    var sx = s.left + s.width / 2, sy = s.top + s.height / 2;
    var dx = c.left + c.width / 2 - sx, dy = c.top + c.height / 2 - sy;
    var outer = document.createElement('div'), inner = document.createElement('div');
    outer.className = 'fly'; inner.className = 'fly__in';
    outer.style.cssText = 'position:fixed;z-index:120;pointer-events:none;left:' + (sx - size / 2) + 'px;top:' + (sy - size / 2) + 'px;width:' + size + 'px;height:' + size + 'px;will-change:transform';
    inner.style.cssText = 'width:100%;height:100%;border-radius:' + (src.tagName === 'IMG' ? '6px' : '50%') + ';overflow:hidden;background:#FE87BF;will-change:transform,opacity;box-shadow:0 6px 18px rgba(14,14,14,.25)';
    if (src.tagName === 'IMG') { var im = src.cloneNode(); im.removeAttribute('loading'); im.alt = ''; im.style.cssText = 'width:100%;height:100%;object-fit:contain;background:var(--surface);padding:6%'; inner.appendChild(im); }
    outer.setAttribute('aria-hidden', 'true'); outer.appendChild(inner); document.body.appendChild(outer);
    var D = 460, done = false;
    function end() { if (done) return; done = true; outer.remove(); land(); }
    outer.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(' + dx + 'px)' }], { duration: D, easing: 'cubic-bezier(.2,.7,.3,1)', fill: 'forwards' });
    var a = inner.animate([
      { transform: 'translateY(0) scale(1)', opacity: 1 },
      { opacity: 1, offset: .8 },
      { transform: 'translateY(' + dy + 'px) scale(.28)', opacity: 0 }
    ], { duration: D, easing: 'cubic-bezier(.55,0,.8,.45)', fill: 'forwards' });
    a.onfinish = end; a.oncancel = end;
    setTimeout(end, D + 400);
  }

  /* ---------- WhatsApp: un pulso a los 4s ---------- */
  var wa = $('.wa');
  if (wa && !R()) {
    setTimeout(function () {
      wa.classList.add('pulse', 'tip');
      setTimeout(function () { wa.classList.remove('tip'); }, 3200);
      setTimeout(function () { wa.classList.remove('pulse'); }, 2600);
    }, 4000);
  }

  window.RVM = {
    refresh: refresh, initAcc: initAcc, roll: roll, rollIn: rollIn, tweenMoney: tweenMoney, shake: shake, bump: bump, fly: fly, go: go,
    onFrame: function (k) { tasks.push(k); schedule(); },
    reduced: R
  };

  initAcc(document);
  measure();
})();
